'use client';

import { useMemo, useRef } from 'react';

import { ContractEditor, ContractEditorRef } from '@/components/ContractEditorNew';

import { ContractItem } from '@/types';
import { stringToFile } from '@/utils';

import { LefPanel } from './LefPanel';
type Props = {
  contract: ContractItem;
  displayPassword?: string;
  file?: any;
  xfdfStrings?: string[];
  showPassword?: (isShow: boolean) => void;
  onLoaded: (instance: any) => void;
  isVisualContractView?: boolean;
  onUserChange?: (contractId: string) => void;
  subContractXfdfStrings?: string[];
  onDownload: (id?: string) => void;
  viewMore?: () => void;
  hasMore?: boolean;
};
export function Detail(props: Props) {
  const pdfEditorRef = useRef<ContractEditorRef>(null);
  const {
    contract,
    displayPassword,
    file,
    showPassword,
    onLoaded,
    isVisualContractView,
    onUserChange,
    subContractXfdfStrings,
    onDownload,
    viewMore,
    hasMore
  } = props;
  const { fileString, annotation } = file || {};
  const xfdfStrings = isVisualContractView ? subContractXfdfStrings : props.xfdfStrings;
  const fileObj = useMemo(
    () => fileString && contract?.title && stringToFile(fileString, contract?.title),
    [fileString, contract?.title]
  );
  const isVoid = contract?.clientStatus === 'void';
  return (
    <div className="flex flex-row h-full pt-[72px]">
      {contract && (
        <LefPanel
          onDownload={onDownload}
          onUserChange={(contractId: string) => {
            onUserChange && onUserChange(contractId);
          }}
          isVisualContractView={isVisualContractView}
          contract={contract}
          showPassword={showPassword}
          displayPassword={displayPassword}
          viewMore={viewMore}
          hasMore={hasMore}
        ></LefPanel>
      )}
      <div className="flex-1 relative ">
        <ContractEditor
          isVoid={isVoid}
          contractName={contract?.title}
          isShow={true}
          file={fileObj}
          xfdfString={annotation}
          xfdfStrings={xfdfStrings}
          ref={pdfEditorRef}
          type="preview"
          onLoaded={(instance) => {
            onLoaded(instance);
          }}
        ></ContractEditor>
      </div>
    </div>
  );
}
